<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">Qualitative Statement</strong>
        </div>
        <div class="col-md-2">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="mb5"></div>
      <div class="row mb-15">
        <div class="col-md-2">
          <button type="button" class="btn btn-sm btn-success" @click="addForm">
            Add
            <i class="fa fa-plus"></i>
          </button>
        </div>
        <div class="col-md-8"></div>
        <div class="col-md-2">
          <!-- <button
            type="button"
            class="btn btn-sm btn-secondary"
            @click="generate"
          >Generate Statements</button> -->
        </div>
      </div>
      <div class v-if="dispAddForm">
        <div class="mb5"></div>
        <!-- <vform :formData="editForm" :fields="fields" :submitCallback="showSmallModal"/> -->
        <form class="form-horizontal" @onsubmit.prevent action>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group" :class="{'has-error': validation.hasError('field_type')}">
                <label class="form-control-label">Fields Type</label>
                <select
                  class="form-control"
                  v-model="field_type"
                  name="field_type"
                >
                  <option value>Select Field Type</option>
                  <option v-for="(f, index) in field_types" :value="f.title" :key="index">{{f.name}}</option>
                </select>
                <div class="error">{{ validation.firstError('field_type') }}</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group" :class="{'has-error': validation.hasError('field')}">
                <label class="form-control-label">Field Collection</label>
                <select class="form-control" v-model="collection_name" name="field">
                  <option value>Select Collection</option>
                  <option
                    v-for="(f, index) in collection"
                    :value="f"
                    :key="index"
                    @change="getFields()"
                  >{{getCustomLabel(f)? getCustomLabel(f): getLabel(f)}}</option>
                </select>
                <div class="error">{{ validation.firstError('field') }}</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group" :class="{'has-error': validation.hasError('field')}">
                <label class="form-control-label">Fields Name</label>
                <select class="form-control" v-model="field" name="field">
                  <option value>Select Field</option>
                  <option
                    v-for="(f, index) in field_names"
                    :value="f"
                    :key="index"
                  >{{getCustomLabel(f)? getCustomLabel(f): getLabel(f)}}</option>
                </select>
                <div class="error">{{ validation.firstError('field') }}</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group" :class="{'has-error': validation.hasError('type')}">
                <label class="form-control-label">Type</label>
                <select class="form-control" v-model="type" name="type">
                  <option value>Select Type</option>
                  <option
                    v-for="(f, index) in fieldsList.types"
                    :value="f"
                    :key="index"
                  >{{getCustomLabel(f)? getCustomLabel(f): getLabel(f)}}</option>
                </select>
                <div class="error">{{ validation.firstError('type') }}</div>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="form-group"
                :class="{'has-error': validation.hasError('sort')}"
              >
                <label class="form-control-label">Sort Order</label>
                <input
                  type="number"
                  v-model="sort"
                  class="form-control"
                />
                <div class="error">{{ validation.firstError('sort') }}</div>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="form-group"
                :class="{'has-error': validation.hasError('is_enabled')}"
              >
                <label class="form-control-label"></label>
                <div class="form-check">
                  <div class="checkbox">
                    <label for="checkbox1" class="form-check-label">
                      <input
                        type="checkbox"
                        id="checkbox1"
                        v-model="is_enabled"
                        class="form-check-input"
                      />{{(is_enabled)? 'Enabled': 'Disabled'}}
                    </label>
                  </div>
                </div>
                <div class="error">{{ validation.firstError('is_enabled') }}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div
                class="form-group"
                :class="{'has-error': validation.hasError('calculate_for_others')}"
              >
                <label class="form-control-label"></label>
                <div class="form-check">
                  <div class="checkbox">
                    <label for="checkbox1" class="form-check-label">
                      <input
                        type="checkbox"
                        id="checkbox1"
                        v-model="calculate_for_others"
                        class="form-check-input"
                      />Calculate For Others
                    </label>
                  </div>
                </div>
                <div class="error">{{ validation.firstError('calculate_for_others') }}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div
                class="form-group"
                :class="{'has-error': validation.hasError('calculate_for_banks')}"
              >
                <label class="form-control-label"></label>
                <div class="form-check">
                  <div class="checkbox">
                    <label for="checkbox2" class="form-check-label">
                      <input
                        type="checkbox"
                        id="checkbox2"
                        v-model="calculate_for_banks"
                        class="form-check-input"
                      />Calculate For Banks
                    </label>
                  </div>
                </div>
                <div class="error">{{ validation.firstError('calculate_for_banks') }}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div
                class="form-group"
                :class="{'has-error': validation.hasError('calculate_for_finance')}"
              >
                <label class="form-control-label"></label>
                <div class="form-check">
                  <div class="checkbox">
                    <label for="checkbox3" class="form-check-label">
                      <input
                        type="checkbox"
                        id="checkbox3"
                        v-model="calculate_for_finance"
                        class="form-check-input"
                      />Calculate For Finance
                    </label>
                  </div>
                </div>
                <div class="error">{{ validation.firstError('calculate_for_finance') }}</div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group" :class="{'has-error': validation.hasError('statement')}">
                <label class="form-control-label">Statement</label>
                <textarea type="text" class="form-control" v-model="statement" :v-html="statement"></textarea>
                <div class="error">{{ validation.firstError('statement') }}</div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="alert alert-secondary" role="alert">
                <span class="badge badge-pill badge-secondary">company_name</span>
                <span class="badge badge-pill badge-secondary">field_name</span>
                <span class="badge badge-pill badge-secondary">current_year</span>
                <span class="badge badge-pill badge-secondary">previous_year</span>
                <span class="badge badge-pill badge-secondary">current_year_raw</span>
                <span class="badge badge-pill badge-secondary">previous_year_raw</span>
                <span class="badge badge-pill badge-secondary">current_year_percent</span>
                <span class="badge badge-pill badge-secondary">previous_year_percent</span>
                <span class="badge badge-pill badge-secondary">verdict</span>
              </div>
            </div>
          </div>
          <div class="raw">
            <div class="col-md-12" v-if="errors && errors.length>0">{{errors}}</div>
          </div>
          <div class="form-group pull-right">
            <button
              type="button"
              @click="submitFrm"
              class="btn btn-info"
            >{{(isEdited)? "Update":"Add"}}</button> &nbsp;&nbsp;
            <button type="button" class="btn btn-danger" @click="cancelForm">Cancel</button>
          </div>
        </form>
        <PinCheck
          :show.sync="show"
          ref="smallModal"
          v-bind:small="true"
          @submitForm="addStmt"
          :cancelClass="'btn btn-secondary'"
        ></PinCheck>
      </div>
      <div class="table-responsive">
        <table class="table fonts11 w60">
          <thead>
            <tr>
              <th>Collection Name</th>
              <th>Field</th>
              <th>Field Type</th>
              <th>Type</th>
              <th>Sort Order</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(qs, index) in qualitativeStmts" :key="index">
              <td>{{getCustomLabel(qs.collection_name)? getCustomLabel(qs.collection_name): getLabel(qs.collection_name)}}</td>
              <td>{{getCustomLabel(qs.field)? getCustomLabel(qs.field): getLabel(qs.field)}}</td>
              <td>{{getCustomLabel(qs.field_type)? getCustomLabel(qs.field_type): getLabel(qs.field_type)}}</td>
              <td>{{getCustomLabel(qs.type)? getCustomLabel(qs.type): getLabel(qs.type)}}</td>
              <td>{{qs.sort}}</td>
              <td>{{(qs.is_enabled)? 'Enabled': 'Disabled'}}</td>
              <td>
                <a
                  style="margin:1px 4px"
                  class="btn btn-sm btn-small btn-primary"
                  v-bind:key="'edit'"
                  @click.prevent="edit(index)"
                >
                  <i :title="'Edit'" class="fa" :class="'fa-edit cwhite'"></i>
                </a>
                <!-- <a
                  style="margin:1px 4px"
                  class="btn btn-sm btn-small btn-danger"
                  v-bind:key="'delete'"
                  @click.prevent="deleteStmt(index)"
                >
                  <i :title="'Delete'" class="fa" :class="'fa-remove cwhite'"></i>
                </a> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
// import vform from "@/components/vform";
import { commonMixins } from "../../assets/mixins/common.js";
import http from "@/lib/http";
import PinCheck from "@/components/PinCheck.vue";
import SimpleVueValidation from "simple-vue-validator";
var Validator = SimpleVueValidation.Validator;
export default {
  name: 'qualitativeStatements',
  components: { PinCheck },
  mixins: [commonMixins],
  created() {
    this.getRawData();
  },
  data() {
    return {
      show: false,
      fieldsList: { fields: [], type: [] },
      field_types: [],
      collection: [],
      field_names: [],
      stmt: {},
      field_type: "",
      field: "",
      collection_name: "",
      type: "",
      statement: "",
      is_enabled: 1,
      sort: 0,
      calculate_for_others: false,
      calculate_for_banks: false,
      calculate_for_finance: false,
      errors: [],
      submitted: false,
      qualitativeStmts: [],
      dispAddForm: false,
      isEdited: false,
      editedRowInd: "",
      editedRowId: '',
      isDel: true,
      frmtype: 'qualitativeStatements'
    };
  },
  validators: {
    field: function(value) {
      return Validator.value(value).required();
    },
    collection_name: function(value) {
      return Validator.value(value).required();
    },
    type: function(value) {
      return Validator.value(value).required();
    },
    sort: function(value) {
      return Validator.value(value).required();
    },
    statement: function(value) {
      return Validator.value(value).required();
    },
    calculate_for_banks: function(value) {
      return Validator.value(value).required();
    },
    calculate_for_finance: function(value) {
      return Validator.value(value).required();
    },
    calculate_for_others: function(value) {
      return Validator.value(value).required();
    }
  },
  methods: {
    submitFrm () {
      if(this.isEdited) {
        console.log(this.formData);
        this.submitEditForm();
      } else {
        this.addStmt();
      }
    },
    submitEditForm: function() {
      let myself = this;
      this.stmt = {
          field_type: this.field_type,
          field: this.field,
          type: this.type,
          collection_name: this.collection_name,
          is_enabled: (this.is_enabled)? 1: 0,
          sort: this.sort,
          statement: this.statement,
          calculate_for_others: this.calculate_for_others,
          calculate_for_banks: this.calculate_for_banks,
          calculate_for_finance: this.calculate_for_finance,
          // _id: this.qualitativeStmts[this.editedRowInd]._id
        };
      console.log("submit form", this.formData, this.stmt);
      http.put(
        "mutual-funds/form?name="+myself.frmtype+"&id="+this.editedRowId,
        this.stmt,
        (error, response) => {
          console.log(response);
          if(response.message == 'success') {
            this.clearForm();
            this.dispAddForm = false;
            this.isEdited = false;
            this.editedRowId = '';
            this.stmt = {};
            this.getRawData();
            this.$toastr.success("Updated Successfully!", "", {});
          } else {
            this.$toastr.error("Oops, Something went wrong!", "", {});
          }
        }
      );
    },
    getRawData() {
      http.get(
        "mutual-funds/form?name="+this.frmtype,
        {},
        (error, response) => {
          if (response.message === 'success') {
            this.fieldsList = response.data.dropdowns;
            var fieldsList = Object.keys(response.data.dropdowns);
            fieldsList.forEach((val, key) => {
              if(key != 'field_type' && key != 'types'){
                this.collection.push(val);
              }
            });
            if(this.fieldsList.field_type){
              this.fieldsList.field_type.forEach((val, key) => {
                this.field_types.push({ title: val, name: this.getLabel(val) });
              });
            }
            console.log(this.fieldsList.field_type, this.field_types);
            this.qualitativeStmts = response.data.documents;
          }
        }
      );
    },
    deleteStmt(index) {
      var data = { field: this.qualitativeStmts[index].field };
      var _this = this;
      http.post("dropQualitativeStatements", data, function(error, response) {
        // if (response.status) {
        _this.$toastr.success(response.status, "", {});
        // }
      });
    },
    showPinCheck() {
      this.submitted = true;
      this.$validate().then(success => {
        // console.log('on success ' + success)
        if (success) {
          this.$refs.smallModal.open();
        }
      });
    },
    generate() {
      // http.get("generate_qualitative_statements", function(error, response) {
      //   // if (!error) {
      //   console.log("response", response);
      //   if (response.responseType === "success") {
      //     _this.$toastr.success(response.msg, "", {});
      //   }
      //   // }
      // });
    },
    addForm() {
      this.dispAddForm = true;
    },
    cancelForm() {
      this.dispAddForm = false;
      this.isEdited = false;
    },
    edit(index) {
      console.log(this.qualitativeStmts[index]);
      this.editedRowInd = index;
      this.editedRowId = this.qualitativeStmts[index]._id;
      this.field_type = this.qualitativeStmts[index].field_type;
      this.collection_name = this.qualitativeStmts[index].collection_name;
      this.getFields();      
      this.field = this.qualitativeStmts[index].field;
      this.type = this.qualitativeStmts[index].type;
      this.statement = this.qualitativeStmts[index].statement;
      this.is_enabled = this.qualitativeStmts[index].is_enabled;
      this.sort = this.qualitativeStmts[index].sort;
      this.calculate_for_others = this.qualitativeStmts[index].calculate_for_others;
      this.calculate_for_banks = this.qualitativeStmts[index].calculate_for_banks;
      this.calculate_for_finance = this.qualitativeStmts[index].calculate_for_finance;
      this.dispAddForm = true;
      this.isEdited = true;
    },
    addStmt() {
      var _this = this;
        this.stmt = {
          field_type: this.field_type,
          field: this.field,
          type: this.type,
          collection_name: this.collection_name,          
          is_enabled: (this.is_enabled)? 1: 0,
          sort: this.sort,
          statement: this.statement,
          calculate_for_others: this.calculate_for_others,
          calculate_for_banks: this.calculate_for_banks,
          calculate_for_finance: this.calculate_for_finance,
        };
      console.log("Statement frm", this.stmt);
      // http.post("mutual-funds/form?name="+this.frmtype, this.stmt, function(
      //   error,
      //   response
      // ) {
      //   if (!error) {
      //     console.log("response", response);
      //     // if (response.status) {
      //     _this.$toastr.success(response.status, "", {});
      //     _this.clearForm();
      //     _this.getQualitativeStmts();
      //     // } else {
      //     //   _this.errors = response.message;
      //     // }
      //   } else {
      //     console.log("error", error);
      //   }
      // });
    },
    clearForm() {
      this.stmt = {};
      this.field = "";
      this.type = "";
    },
    getFields() {
      console.log(
        this.field_type,
        this.fieldsList,
        this.fieldsList["keys_" + this.field_type]
      );
      this.field_names = this.fieldsList[this.collection_name];
    },
  },
  watch: {
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/qualitative-statements.vue